export default "__VITE_ASSET__B8UT$q2C__"